import ErroQuestionarioOpcao from './ErroQuestionarioOpcao';

/**
 * Objeto para armazenar as mensagens de erro da questão
 */
class ErroQuestionarioQuestao {

    /**
     * Cria uma nova instância da lista de erros da questão
     * Caso os parâmetros não sejam informados, cria com valores padrão
     * 
     * @param {Boolean} valido Indica se o objeto é valido ou não
     * @param {String} erroQuestao Mensagem de erro geral do objeto
     * @param {String} titulo Mensagem de erro para o título
     * @param {String} obrigatoria Mensagem de erro para o campo obrigatório
     * @param {String} exibeGrafico Mensagem de erro para o campo exibeGrafico
     * @param {String} tipo Mensagem de erro para o tipo
     * @param {String} opcaoOutros Mensagem de erro para o campo opcaoOutros
     * @param {String} limitaValor Mensagem de erro para o campo limitaValor
     * @param {String} valorMinimo Mensagem de erro para o campo valorMinimo
     * @param {String} valorMaximo Mensagem de erro para o campo valorMaximo
     * @param {String} conteudoTexto Mensagem de erro para o campo conteudoTexto
     * @param {String} exibeResultado Mensagem de erro para o campo exibeResultado
     * @param {String} erroOpcoes Mensagem de erro relativo a lista de opções de resposta
     * @param {Array<ErroQuestionarioOpcao>} opcoes Lista com os erros das opções de resposta
     */
    constructor(valido, erroQuestao, titulo, obrigatoria, exibeGrafico, tipo, opcaoOutros, limitaValor, valorMinimo, valorMaximo, conteudoTexto, exibeResultado, erroOpcoes, opcoes) {
        /** @member {Boolean} valido Indica se o objeto é valido ou não */
        this.valido = valido ?? true;
        /** @member {String} erroQuestao Mensagem de erro geral do objeto */
        this.erroQuestao = erroQuestao ?? '';
        /** @member {String} titulo Mensagem de erro para o título */
        this.titulo = titulo ?? '';
        /** @member {String} obrigatoria Mensagem de erro para o campo obrigatório */
        this.obrigatoria = obrigatoria ?? '';
        /** @member {String} exibeGrafico Mensagem de erro para o campo exibeGrafico */
        this.exibeGrafico = exibeGrafico ?? '';
        /** @member {String} tipo Mensagem de erro para o tipo */
        this.tipo = tipo ?? '';
        /** @member {String} opcaoOutros Mensagem de erro para o campo opcaoOutros */
        this.opcaoOutros = opcaoOutros ?? '';
        /** @member {String} erroOpcoes Mensagem de erro relativo a lista de opções de resposta */
        this.erroOpcoes = erroOpcoes ?? '';
        /** @member {String} limitaValor Mensagem de erro para o campo limitaValor */
        this.limitaValor = limitaValor ?? '';
        /** @member {String} valorMinimo Mensagem de erro para o campo valorMinimo */
        this.valorMinimo = valorMinimo ?? '';
        /** @member {String} valorMaximo Mensagem de erro para o campo valorMaximo */
        this.valorMaximo = valorMaximo ?? '';
        /** @member {String} conteudoTexto Mensagem de erro para o campo conteudoTexto */
        this.conteudoTexto = conteudoTexto ?? '';
        /** @member {String} exibeResultado Mensagem de erro para o campo exibeResultado */
        this.exibeResultado = exibeResultado ?? '';
        /** @member {Array<ErroQuestionarioOpcao>} opcoes Lista com os erros das opções de resposta */
        this.opcoes = opcoes ?? [];
    }

    /**
     * Verifica se dois objetos possuem os mesmos valores
     * @param {ErroQuestionarioQuestao} obj1 Primeiro objeto a ser comparado
     * @param {ErroQuestionarioQuestao} obj2 Segundo objeto a ser comparado
     * @returns {Boolean} Retorna verdadeiro se os dois objetos forem iguais
     */
    static compare(obj1, obj2) {
        //Se os dois possuírem o mesmo endereço de memória
        if (obj1 === obj2)
            return true;
        //Se um dos dois for nulo
        if (!obj1 || !obj2)
            return false;
        //Compara as propriedades
        let result = obj1.valido === obj2.valido
                  && obj1.erroQuestao === obj2.erroQuestao
                  && obj1.titulo === obj2.titulo
                  && obj1.obrigatoria === obj2.obrigatoria
                  && obj1.exibeGrafico === obj2.exibeGrafico
                  && obj1.tipo === obj2.tipo
                  && obj1.opcaoOutros === obj2.opcaoOutros
                  && obj1.erroOpcoes === obj2.erroOpcoes
                  && obj1.limitaValor === obj2.limitaValor
                  && obj1.valorMinimo === obj2.valorMinimo
                  && obj1.valorMaximo === obj2.valorMaximo
                  && obj1.conteudoTexto === obj2.conteudoTexto
                  && obj1.exibeResultado === obj2.exibeResultado;

        //Caso as propriedades sejam iguais, verifica as listas
        if (result) {
            return ErroQuestionarioQuestao.compareOpcoes(obj1.opcoes, obj2.opcoes);
        } else {
            return false;
        }
    }

    /**
     * Compara a lista de erros das opções da questão
     * @param {Array<ErroQuestionarioOpcao>} list1 Lista de erros das opções do primeiro objeto
     * @param {Array<ErroQuestionarioOpcao>} list2 Lista de erros das opções do segundo objeto
     * @returns {Boolean} Retorna verdadeiro se os itens das duas listas são iguais
     */
    static compareOpcoes(list1, list2) {
        //Se as duas listas possuírem o mesmo endereço de memória
        if (list1 === list2)
            return true;
        //Se uma das duas for nula
        if (!list1 || !list2)
            return false;
        //Se os tamanhos forem diferentes
        if (list1.length !== list2.length)
            return false;
        //Verifica se existe algum item que seja diferente entre as listas
        for (let i = 0; i < list1.length; i++) {
            if (!ErroQuestionarioOpcao.compare(list1[i], list2[i]))
                return false;
        }
        return true;
    }

}

export default ErroQuestionarioQuestao;